// extracted by mini-css-extract-plugin
export default {"cardBordered":"amLwAH","external":"bmLwAH","override":"cmLwAH","selected":"dmLwAH","cardContent":"emLwAH","column":"fmLwAH","columnReverse":"gmLwAH"};